/* eslint-disable */
/* global window, document, URL, Blob */
import angular from 'angular';
import * as R from 'ramda';

export default function DocumentManagementDialogController(
  $q,
  $rootScope,
  $scope,
  addEditFolderDialog,
  addEditDocumentDialog,
  alerts,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  uploadDocumentDialog,
  documentAssociationDialog,
  $animate,
) {
  const vm = this;

  vm.isRoot = true;
  vm.attachedIds = vm.attachedIds || [];
  vm.documentAssociationDialog = null;

  vm.handleCloseDialogClick = handleCloseDialogClick;
  vm.handleEditFolderDialogClick = handleEditFolderDialogClick;
  vm.handleEditDocumentDialogClick = handleEditDocumentDialogClick;
  vm.handleAddFolderDialogClick = handleAddFolderDialogClick;
  vm.handleDeleteFolderClick = handleDeleteFolderClick;
  vm.handleYesDeleteFolderDialogClick = handleYesDeleteFolderDialogClick;
  vm.handleCloseDeleteFolderDialogClick = handleCloseDeleteFolderDialogClick;
  vm.handleFolderDeleted = _handleFolderDeleted;
  vm.handleDownloadClick = handleDownloadClick;
  vm.handleAddDocumentDialogClick = handleAddDocumentDialogClick;
  vm.handleDeleteDocumentClick = handleDeleteDocumentClick;
  vm.handleYesDeleteDocumentDialogClick = handleYesDeleteDocumentDialogClick;
  vm.handleCloseDeleteDocumentDialogClick = handleCloseDeleteDocumentDialogClick;
  vm.handleDocumentInsert = handleDocumentInsert;
  vm.handleExpandClick = handleExpandClick;
  vm.handleDocumentMovedropCallback = handleDocumentMovedropCallback;
  vm.handleAttachDocumentsFormSubmit = handleAttachDocumentsFormSubmit;
  vm.handleRefreshFolderDialogClick = _handleRefreshFolderDialogClick;

  activate();

  // //////// METHODS //////////

  /** *******************************************************
   * Private Functions
   */

  function activate() {
    loaderService.showViewLoader = true;
    if (!vm.customerServices || !vm.folderList) {
      $q.all([
        _loadDocumentManagement(),
        _loadCustomerServices()
      ]).then(() => {
        loaderService.showViewLoader = false;
      });
    } else {
      _recursivelyResetAttachments(vm.folderList);
      loaderService.showViewLoader = false;
    }
  }

  function _loadDocumentManagement() {
    return docDataService.getItemList(vm.serviceId, vm.parentFolderId, vm.attachmentTypeId, vm.attachmentEntityId)
      .then((res) => {
        vm.folderList = res.data.result;
        // Open all folders by default - commented out JG due to loading time issues
        /*
        angular.forEach(vm.folderList, (folder) => {
          if (folder.hasAttachment) {
            folder.isExpanded = true;
          } else {
            folder.isExpanded = false;
          }
        });
        */
      });
  }

  function _loadCustomerServices() {
    return orgDataService.getServicesForUser().then((res) => {
      vm.customerServices = [];

      const vmService = R.find(R.propEq('serviceId', 1), res.data.result);
      if (vmService) {
        vm.customerServices.push({
          serviceId: vmService.serviceId,
          name: vmService.name,
        });
      }

      const eCatService = R.find(R.propEq('serviceId', 9), res.data.result);
      if (eCatService) {
        vm.customerServices.push({
          serviceId: eCatService.serviceId,
          name: eCatService.name,
        });
      }

      const amService = R.find(R.propEq('serviceId', 17), res.data.result);
      if (amService) {
        vm.customerServices.push({
          serviceId: amService.serviceId,
          name: amService.name,
        });
      }
    });
  }

  function _recursivelyResetAttachments(folders) {
    if (folders && folders.length > 0) {
      folders.forEach((folder) => {
        if (folder.documents && folder.documents.length > 0) {
          folder.documents.forEach((document) => {
            if (vm.attachedIds.includes(document.documentId)) {
              document.isAttached = true;
            } else {
              document.isAttached = false;
            }
          });
        }
        _recursivelyResetAttachments(folder.folders);
      });
    }
  }

  function _closeDialog() {
    loaderService.showViewLoader = false;
    if (vm.onCloseCallBack) {
      vm.onCloseCallBack({
        folderList: vm.folderList,
        customerServices: vm.customerServices,
      });
    }
    return ssDialogService.hide(ssDialogService.dialogs.global.documentMangementDialog);
  }

  function handleCloseDialogClick() {
    _closeDialog();
  }

  /** *******************************************************
   * Event Handlers
   */

  // ------------------- Folder ----------------------------
  function handleEditFolderDialogClick($event, folder, parentFolder) {
    folder.customerServices = vm.customerServices;
    ssDialogService.dialogs.global.addEditFolderDialog = ssDialogService.alert(
      addEditFolderDialog.getOptions(
        $event, {
          parentFolderId: folder.parentFolderId,
          folderId: folder.folderId,
          customerId: vm.customerId,
          serviceId: vm.serviceId,
          folderName: folder.folderName,
          folder,
          parentFolder,
          maxSubFolderNameLength: 100,
          updateCallback: _handleFolderUpdated,
        },
      ),
    );
    return ssDialogService.show(ssDialogService.dialogs.global.addEditFolderDialog);
  }

  function _handleAcceptFolderAssociationDelete($event, folderObj) {
    ssDialogService.dialogs.global.documentManagementDeleteFolderDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Folder?',
        message: `Are you sure you want to delete the ${folder.folderName} folder?`,
        handleYesClick: vm.handleYesDeleteFolderDialogClick,
        handleNoClick: vm.handleCloseDeleteFolderDialogClick,
        referenceObject: folderObj,
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.global.documentManagementDeleteFolderDialog);
  }

  function handleDeleteFolderClick($event, parentFolder, folder) {
    loaderService.showViewLoader = true;

    const dfdAssoc = docDataService.getDocumentAssociationsByFolder(folder.folderId, this.serviceId);

    dfdAssoc.then((isSuccess) => {
      if ((isSuccess.statusText === 'OK') || (isSuccess.statusText === '')) {
        if (isSuccess.data.length > 0)
        {
          const outsideAssocs = R.filter(d => d.serviceId != vm.serviceId, isSuccess.data);

          let message = `Are you sure you want to delete the ${folder.folderName} folder?`;
          message = "This folder has files associated with items. " + message;

          ssDialogService.dialogs.global.documentManagementDeleteFolderDialog = ssDialogService.alert(
            confirmDialog.getOptions($event, {
              dialogTitle: 'Delete Folder?',
              message: message,
              handleYesClick: vm.handleYesDeleteFolderDialogClick,
              handleNoClick: vm.handleCloseDeleteFolderDialogClick,
              referenceObject: {
                parentFolder,
                folder,
              },
            }),
          );

          ssDialogService.show(ssDialogService.dialogs.global.documentManagementDeleteFolderDialog);
          // _showDocumentAssociationsDialog($event, {
          //   folderId: folder.folderId,
          //   documentId: null,
          //   serviceId: this.serviceId,
          //   associations: isSuccess.data,
          //   document: null,
          //   folderObj: {
          //     folder,
          //     parentFolder
          //   },
          //   acceptCallback: _handleAcceptFolderAssociationDelete
          // });
        } else {
          ssDialogService.dialogs.global.documentManagementDeleteFolderDialog = ssDialogService.alert(
            confirmDialog.getOptions($event, {
              dialogTitle: 'Delete Folder?',
              message: `Are you sure you want to delete the ${folder.folderName} folder?`,
              handleYesClick: vm.handleYesDeleteFolderDialogClick,
              handleNoClick: vm.handleCloseDeleteFolderDialogClick,
              referenceObject: {
                parentFolder,
                folder,
              },
            }),
          );

          ssDialogService.show(ssDialogService.dialogs.global.documentManagementDeleteFolderDialog);
        }
      } else {
        alerts.error('Error occurred while deleting Folder.');
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
      // return ssDialogService.hide(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
    });
  }

  function handleYesDeleteFolderDialogClick(folderObj) {
    loaderService.showViewLoader = true;

    const parentFolder = folderObj.parentFolder;
    const folder = folderObj.folder;

    const dfdDeleteFolder = docDataService.deleteFolder(folder.folderId);
    dfdDeleteFolder.then((isSuccess) => {
      if ((isSuccess.statusText === 'OK') || (isSuccess.statusText === '')) {
        alerts.success(`Folder ${folder.folderName} has been deleted successfully.`);
        vm.handleFolderDeleted(parentFolder, folder);
      } else {
        alerts.error('Error occurred while deleting Folder.');
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
      return ssDialogService.hide(ssDialogService.dialogs.global.documentManagementDeleteFolderDialog);
    });
  }

  function handleAddFolderDialogClick($event, parentFolder) {
    const fvs = [];
    const fv = { serviceId: Number(vm.serviceId) };
    fvs.push(fv);

    const folder = {
      customerServices: vm.customerServices,
      folderVisibilities: fvs,
    };

    ssDialogService.dialogs.global.addEditFolderDialog = ssDialogService.alert(
      addEditFolderDialog.getOptions(
        $event, {
          parentFolderId: parentFolder.folderId,
          folderId: 0,
          customerId: vm.customerId,
          serviceId: vm.serviceId,
          folder,
          parentFolder,
          maxSubFolderNameLength: parentFolder.maxNewSubFolderNameLength,
          updateCallback: _handleFolderAdded,
        },
      ),
    );
    return ssDialogService.show(ssDialogService.dialogs.global.addEditFolderDialog);
  }

  function handleCloseDeleteFolderDialogClick() {
    return ssDialogService.hide(ssDialogService.dialogs.global.documentManagementDeleteFolderDialog);
  }

  function _handleFolderAdded(parentFolder, folder) {
    try {
      parentFolder.folders = R.append(folder, parentFolder.folders);
      parentFolder.folders = R.sortBy(
        f => f.folderName,
        parentFolder.folders,
      );
      parentFolder.isExpanded = true;
      setFolderChildCount(parentFolder);
    } catch (err) {
      console.error(err);
    }
  }

  function _handleFolderUpdated(parentFolder, updatedFolder) {
    try {
      angular.forEach(parentFolder.folders, (folder, index) => {
        if (updatedFolder.folderId === folder.folderId) {
          // check if the folder still is available in this service
          const visIndex = updatedFolder.folderVisibilities.findIndex(d => d.serviceId === Number(vm.serviceId));

          if (visIndex > -1) {
            folder.customerServices = updatedFolder.customerServices;
            folder.folderVisibilities = updatedFolder.folderVisibilities;
          } else {
            parentFolder.folders = R.remove(index, 1, parentFolder.folders);
            parentFolder.folders = R.sortBy(
              f => f.folderName,
              parentFolder.folders,
            );

            setFolderChildCount(parentFolder);
          }
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  function _handleFolderDeleted(parentFolder, folder) {
    try {
      const folderIndex = parentFolder.folders.findIndex(
        f => f.folderId === folder.folderId,
        // R.propEq('folderId', folder.folderId)
      );

      if (folderIndex > -1) {
        parentFolder.folders = R.remove(folderIndex, 1, parentFolder.folders);
        parentFolder.folders = R.sortBy(
          f => f.folderName,
          parentFolder.folders,
        );

        setFolderChildCount(parentFolder);
        $rootScope.$broadcast('reloadVMData', {} );
      }
    } catch (err) {
      console.error(err);
    }
  }

  function _handleRefreshFolderDialogClick() {
    _loadDocumentManagement();
  }

  // ---------------- Document --------------------

  function handleDownloadClick($event, doc) {
    alerts.success('The file download will start momentarily.');
    return orgDataService.downloadDocument(doc.documentId, vm.customerId)
      .then((response) => {
        const blob = new Blob(
          [response.data],
          { type: doc.mimeType, }
        );
        // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, doc.fileName);
        } else {
          const anchor = document.createElement('a');
          document.body.appendChild(anchor);
          anchor.setAttribute('type', 'hidden');

          anchor.href = URL.createObjectURL(blob);
          anchor.download = doc.fileName;
          anchor.target = '_self';
          anchor.click();
        }
      });
  }

  function handleEditDocumentDialogClick($event, folder, doc) {
    doc.customerServices = vm.customerServices;
    ssDialogService.dialogs.global.addEditDocumentDialog = ssDialogService.alert(
      addEditDocumentDialog.getOptions(
        $event, {
          folderId: folder.folderId,
          documentId: doc.documentId,
          customerId: vm.customerId,
          serviceId: vm.serviceId,
          documentName: doc.name,
          parentFolder: folder,
          document: doc,
          updateCallback: _handleDocumentUpdated,
        },
      ),
    );
    return ssDialogService.show(ssDialogService.dialogs.global.addEditDocumentDialog);
  }

  function handleAddDocumentDialogClick($event, folder) {
    if (!folder.isExpanded && folder.childrenCount > 0) {
      loaderService.showViewLoader = true;
      folder.folders = null;
      folder.documents = null;
      $animate.enabled(false);
      docDataService.getItemList(vm.serviceId, folder.folderId, vm.attachmentTypeId, vm.attachmentEntityId)
        .then((res) => {
          folder.folders = res.data.result[0].folders;
          folder.documents = res.data.result[0].documents;
          $animate.enabled(true);
          loaderService.showViewLoader = false;
        });
    }
    ssDialogService.dialogs.global.uploadDocumentDialog = ssDialogService.alert(
      uploadDocumentDialog.getOptions($event, {
        parentFolderId: folder.folderId,
        parentFolder: folder,
        // customerId: vm.customerId,
        serviceId: vm.serviceId,
        documentId: 0,
        updateCallback: _handleDocumentAdded,
      }),
    );
    return ssDialogService.show(ssDialogService.dialogs.global.uploadDocumentDialog);
  }


  function _showDocumentAssociationsDialog($event, locals) {
    ssDialogService.dialogs.global.documentAssociationDialog = ssDialogService.alert(
      documentAssociationDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.global.documentAssociationDialog);
  }

  function _handleAcceptDocumentAssociationDelete($event, parentFolder, document, serviceId) {
    ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Document?',
        message: `Are you sure you want to delete the ${document.name} document?`,
        handleYesClick: vm.handleYesDeleteDocumentDialogClick,
        handleNoClick: vm.handleCloseDeleteDocumentDialogClick,
        referenceObject: {
          parentFolder,
          document,
          serviceId
        },
      }),
    );

    ssDialogService.show(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
  }

  function handleDeleteDocumentClick($event, parentFolder, document) {
    loaderService.showViewLoader = true;

    const dfdAssoc = docDataService.getDocumentAssociations(document.documentId, this.serviceId);

    dfdAssoc.then((isSuccess) => {
      if ((isSuccess.statusText === 'OK') || (isSuccess.statusText === '')) {
        if (isSuccess.data.length > 0)
        {
          const outsideAssocs = R.filter(d => d.serviceId != vm.serviceId, isSuccess.data);

          let message = `Are you sure you want to delete the ${document.name} document?`;
          message = "This file is associated with items. " + message;

          ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog = ssDialogService.alert(
            confirmDialog.getOptions($event, {
              dialogTitle: 'Delete Document?',
              message: message,
              handleYesClick: vm.handleYesDeleteDocumentDialogClick,
              handleNoClick: vm.handleCloseDeleteDocumentDialogClick,
              referenceObject: {
                parentFolder,
                document,
              },
            }),
          );

          ssDialogService.show(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);

            // _showDocumentAssociationsDialog($event, {
            //   folderId: null,
            //   documentId: document.documentId,
            //   serviceId: this.serviceId,
            //   associations: isSuccess.data,
            //   document: document,
            //   acceptCallback: _handleAcceptDocumentAssociationDelete
            // });
        } else {
          ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog = ssDialogService.alert(
            confirmDialog.getOptions($event, {
              dialogTitle: 'Delete Document?',
              message: `Are you sure you want to delete the ${document.name} document?`,
              handleYesClick: vm.handleYesDeleteDocumentDialogClick,
              handleNoClick: vm.handleCloseDeleteDocumentDialogClick,
              referenceObject: {
                parentFolder,
                document,
              },
            }),
          );

          ssDialogService.show(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
        }
      } else {
        alerts.error('Error occurred while deleting Document.');
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
      // return ssDialogService.hide(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
    });
  }

  function handleYesDeleteDocumentDialogClick(documentObject) {
    loaderService.showViewLoader = true;

    const document = documentObject.document;
    const parentFolder = documentObject.parentFolder;

    const dfdDelete = docDataService.deleteDocument(document.documentId, vm.customerId, vm.serviceId);
    dfdDelete.then((isSuccess) => {
      if ((isSuccess.statusText === 'OK') || (isSuccess.statusText === '')) {
        alerts.success(`Document ${document.name} has been deleted successfully.`);
        _handleDocumentDeleted(parentFolder, document);
      } else {
        alerts.error('Error occurred while deleting Document.');
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
      return ssDialogService.hide(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
    });
  }

  function handleCloseDeleteDocumentDialogClick() {
    return ssDialogService.hide(ssDialogService.dialogs.global.documentManagementDeleteDocumentDialog);
  }

  function handleDocumentInsert(event, folder, document) {
    if (!!folder && !!document) {
      if (folder.folderId !== document.folderId) {
        // Move the document
        loaderService.showViewLoader = true;
        const dfdMove = docDataService.moveDocument(vm.customerId, folder.folderId, document.documentId);
        dfdMove.then((isSuccess) => {
          if (isSuccess.status === 200) {
            alerts.success('Document has been moved successfully.');
            setFolderChildCount(folder);
            folder.isExpanded = true;
          } else {
            alerts.error('Error occurred while moving Document.');
          }
          // _loadDocumentManagement();
        }).finally(() => {
          loaderService.showViewLoader = false;
        });
      }
    }
  }

  function _handleDocumentAdded(parentFolder, documents) {
    documents.forEach((document) => {
      parentFolder.documents = R.append(document, parentFolder.documents);
    });
    parentFolder.documents = R.sortBy(
      d => d.name,
      parentFolder.documents,
    );
    parentFolder.isExpanded = true;
    setFolderChildCount(parentFolder);
  }

  function _handleDocumentUpdated(parentFolder, updatedDocument) {
    try {
      angular.forEach(parentFolder.documents, (doc, index) => {
        if (updatedDocument.documentId === doc.documentId) {
          // check if the document still is available in this service
          const visIndex = updatedDocument.documentVisibilities.findIndex(d => d.serviceId === Number(vm.serviceId));

          if (visIndex > -1) {
            doc.customerServices = updatedDocument.customerServices;
            doc.documentVisibilities = updatedDocument.documentVisibilities;
          } else {
            parentFolder.documents = R.remove(index, 1, parentFolder.documents);
            parentFolder.documents = R.sortBy(
              d => d.name,
              parentFolder.documents,
            );
            setFolderChildCount(parentFolder);
          }
        }
      });
    } catch (err) {
      console.error(err);
    }
  }

  function _handleDocumentDeleted(parentFolder, document) {
    try {
      const documentIndex = parentFolder.documents.findIndex(
        d => d.documentId === document.documentId,
        // R.propEq('folderId', folder.folderId)
      );

      if (documentIndex > -1) {
        parentFolder.documents = R.remove(documentIndex, 1, parentFolder.documents);
        parentFolder.documents = R.sortBy(
          d => d.name,
          parentFolder.documents,
        );

        setFolderChildCount(parentFolder);
        $rootScope.$broadcast('refreshAMDocuments', { documentId: document.documentId });
        $rootScope.$broadcast('refreshVMDocuments', { documentId: document.documentId });
      }
    } catch (err) {
      console.error(err);
    }
  }

  function handleExpandClick($event, folder) {
    // const folder = $event.currentTarget;
    folder.isExpanded = !folder.isExpanded;
  }

  // eslint-disable-next-line no-unused-vars
  function handleDocumentMovedropCallback(index, item, external, type) {
    // DO nothing
  }

  // function GetAttachedDocument(folders, docs) {
  //   angular.forEach(folders, (folder, i) => {
  //     if (folder.documents !== null && folder.documents.length > 0 && i > -1) {
  //       angular.forEach(folder.documents, (d, j) => {
  //         if (d.isAttached === true && j > -1) {
  //           docs.push(d);
  //         }
  //       });
  //     }
  //     if (folder.folders !== null && folder.folders.length > 0) {
  //       GetAttachedDocument(folder.folders, docs);
  //     }
  //   });
  // }

  function handleAttachDocumentsFormSubmit() {
    const documents = [];
    // GetAttachedDocument(vm.folderList, documents);
    _closeDialog().then(() => {
      vm.attachCallback(vm.attachedIds, documents);
    });
  }

  function setFolderChildCount(folder) {
    let folderCount = 0;
    let docCount = 0;

    if (folder.folders) { folderCount = folder.folders.length; }
    if (folder.documents) { docCount = folder.documents.length; }

    folder.childrenCount = folderCount + docCount;
  }
}

DocumentManagementDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'addEditFolderDialog',
  'addEditDocumentDialog',
  'alerts',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'uploadDocumentDialog',
  'documentAssociationDialog',
  '$animate'
];
